import { useQuery } from 'react-query'

import { licenseApi } from '@/app/services/licenseApi'

export function useLicenseStatus() {
  return useQuery({
    queryKey: ['license-status'],
    queryFn: licenseApi.getStatus,
    staleTime: 60_000,
  })
}
